import AppleSignin, { AppleAuthResponse } from 'react-apple-signin-auth'

import { noop } from '~/utils/function'
import { getRegionSpecificValue } from '~/utils/getRegionSpecificValue'
import { useRegion } from '~/utils/hooks'

import { useAppleSignInMutation } from '~/app/generated/graphql'
import { gt } from '~/lib/gt'

import { RegisterSignInCallback } from '../AuthModals/RegisterModal/RegisterModalView'
import LoginButton from '../LoginButton'

export type AppleLoginButtonProps = {
  onLogin?: RegisterSignInCallback
  label?: string
}

const AppleLoginButton = ({ onLogin, label }: AppleLoginButtonProps) => {
  const [appleSignIn] = useAppleSignInMutation()
  const region = useRegion()

  const SERVICE_ID = getRegionSpecificValue({
    region,
    pl: process.env.NEXT_PUBLIC_PL_APPLE_SERVICE_ID,
    cz: process.env.NEXT_PUBLIC_CZ_APPLE_SERVICE_ID,
    de: process.env.NEXT_PUBLIC_DE_APPLE_SERVICE_ID,
    default: process.env.NEXT_PUBLIC_PL_APPLE_SERVICE_ID,
  })

  return (
    <AppleSignin
      render={(props: { onClick: () => void }) => {
        return <LoginButton icon='apple' label={label ?? gt.tp('Login', 'Sign in with Apple')} {...props} />
      }}
      authOptions={{
        clientId: SERVICE_ID || '',
        scope: 'email name',
        redirectURI: process.env.NEXT_PUBLIC_CLUB_URL + '/callback/apple',
        usePopup: true,
      }}
      onError={noop}
      onSuccess={async (res: AppleAuthResponse) => {
        const user = res.user?.name
        const signInResponse = await appleSignIn({
          variables: { appleIdentityToken: res.authorization.id_token, firstName: user?.firstName, lastName: user?.lastName },
        })

        onLogin?.(signInResponse.data?.appleSignIn.user ?? null, true)
      }}
      uiType='light'
    />
  )
}

export default AppleLoginButton
